import { makeStyles, createStyles } from '../../styles';
export default makeStyles((theme) => createStyles({
    root: {
        backgroundColor: theme.palette.background.default,
    },
}));
//# sourceMappingURL=Paper.styles.js.map